import { useParams } from 'next/navigation'

const rtlRouteLocale = ['ae']

export default function useDir() {
  const params = useParams<{ locale: string }>()
  return rtlRouteLocale.includes(params.locale) ? 'rtl' : 'ltr'
}
